"use client";

import { c as _c } from "react/compiler-runtime";
import { SukhaBugLogoImage } from "@/components/shared/SukhaBugLogoImage";
import { cn } from "@/lib/utils";
interface AgentToastProps {
  title: string;
  message: string;
  className?: string;
}
export function AgentToast(t0) {
  const $ = _c(13);
  const {
    title,
    message,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex items-center gap-3", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SukhaBugLogoImage alt="Agent" className="h-8 w-auto shrink-0" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== title) {
    t3 = <div className="font-semibold text-white">{title}</div>;
    $[3] = title;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== message) {
    t4 = <div className="text-white/90 text-sm">{message}</div>;
    $[5] = message;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className="flex-1 min-w-0">{t3}{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t1 || $[11] !== t5) {
    t6 = <div className={t1}>{t2}{t5}</div>;
    $[10] = t1;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}